import { render, staticRenderFns } from "./tabs-body-pane.vue?vue&type=template&id=1c234243&scoped=true&"
import script from "./tabs-body-pane.vue?vue&type=script&lang=js&"
export * from "./tabs-body-pane.vue?vue&type=script&lang=js&"
import style0 from "./tabs-body-pane.vue?vue&type=style&index=0&id=1c234243&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c234243",
  null
  
)

export default component.exports